import styled, { css } from "styled-components";
import { LoginWrapper } from "../Login/styles";

export const Form = styled.form`
  display: flex;
  flex-direction: column;
  gap: 25px;
`;

export const ForgotPasswordButton = styled.button`
  ${({ theme }) => css`
    display: flex;
    align-items: center;
    font-size: 16px;
    color: ${theme.darkTheme.colors.gray};
    text-decoration: none;
    font-weight: 100;
    background-color: transparent;
    border: 0;
    text-align: start;
    span {
      color: ${theme.darkTheme.colors.white};
    }
    :hover {
      color: ${theme.darkTheme.colors.gray};
      text-decoration: none;
    }
  `}
`;

export const ForgotPasswordAlertLink = styled.span`
  cursor: pointer;
  text-decoration: underline;
`;

export { LoginWrapper };
